import React from 'react';
import { useTranslation } from 'react-i18next';

import ConceptSection from './ConceptSection';
import PositiveConceptChart from '../charts/PositiveConceptChart';

function PositiveSection({ selectedConcept, isGlobalPercentageEnabled }) {
  const { t } = useTranslation('resonance');

  return (
    <ConceptSection
      title={t('positive')}
      selectedConcept={selectedConcept}
      isGlobalPercentageEnabled={isGlobalPercentageEnabled}>
      {({ compareConcepts, isGlobalPercentage }) => (
        <PositiveConceptChart
          compareConcepts={compareConcepts}
          selectedConcept={selectedConcept}
          isGlobalPercentage={isGlobalPercentage}
        />
      )}
    </ConceptSection>
  );
}

export default PositiveSection;
